import { Icon } from "icons";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import {
  Button,
  ButtonGroup,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "ui";

import { InsertButton } from "src/components/LinkWorkoutItemsInsertButton";
import { type UnlinkButtonGroupProps } from "src/workouts/LinkUnlinkWorkoutItemsButton";
import { useUnlinkWorkoutItem } from "src/workouts/useUnlinkWorkoutItem";
import { useWorkoutEditStore } from "src/workouts/WorkoutEditContext";

export const UnlinkButtonGroup = observer(function UnlinkButtonGroup(
  props: UnlinkButtonGroupProps,
) {
  const { t } = useTranslation();
  const workoutEditStore = useWorkoutEditStore();
  const { unlink, isLoading } = useUnlinkWorkoutItem();

  const isInsideSuperset = workoutEditStore.isInsideSuperset(props.itemId);

  if (!isInsideSuperset) {
    return (
      <ButtonGroup>
        <InsertButton
          onInsert={props.onInsert}
          sections={props.sections}
          onAddSection={props.onAddSection}
          onImportFromLibrary={props.onImportFromLibrary}
        />
      </ButtonGroup>
    );
  }

  function handleUnlink() {
    const previousItem = workoutEditStore.getWorkoutItemById(
      props.previousItemId,
    );
    const isFirstChild = previousItem.order === 0;
    unlink(isFirstChild ? props.previousItemId : props.itemId);
  }

  return (
    <ButtonGroup>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="outline"
            size="icon-sm"
            disabled={isLoading}
            onClick={handleUnlink}
          >
            <Icon name="tabler-unlink" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>{t("editWorkout.unlink.tooltip")}</TooltipContent>
      </Tooltip>
      <InsertButton
        onInsert={props.onInsert}
        sections={props.sections}
        onAddSection={props.onAddSection}
        onImportFromLibrary={props.onImportFromLibrary}
      />
    </ButtonGroup>
  );
});
